import { useCallback } from 'react';
import { FirebaseAuthenticationClient } from '@framework/firebase/auth';
import { useStoreRequestPath } from './useStoreRequestPath';
import { useStoreSignUpMode } from './useStoreSignUpMode';

type Options = { withInvitation?: boolean };

/**
 * Firebase Auth(Google リダイレクト)で新規登録/ログインを開始するフック。
 *
 * redirect を跨いで「戻り先(requestPath)」と「登録モード(signUpMode)」を Cookie に保存してから
 * signInWithRedirectToGoogle を呼ぶ。復帰後に pendingRegistration へ入った際、
 * buildRegistrationDraft が signUpMode を、FirebaseSignUpPage が登録完了後の遷移に requestPath を利用する。
 *
 * 招待経由(withInvitation)の場合は requestPath が招待ページURLになり、登録完了後に招待ページへ戻って
 * 既存の自動グループ参加処理が走る。
 */
export const useFirebaseAuthRedirectWithGoogle = () => {
  const { store: storeRequestPath } = useStoreRequestPath();
  const { store: storeSignUpMode } = useStoreSignUpMode();

  return useCallback(
    async (options?: Options) => {
      storeRequestPath();
      storeSignUpMode(options?.withInvitation ? 'withInvitation' : 'withoutInvitation');
      await FirebaseAuthenticationClient.signInWithRedirectToGoogle();
    },
    [storeRequestPath, storeSignUpMode]
  );
};
